<section class="content">
    <div class="row homepage">
      <div class="col-lg-12 col-xs-12">
        <div class="lottie">
          <ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
        </div>
        <div class="message"> {{'genericErrorMessages.pageNotFound' | translate}}</div>
      </div>
    </div>
  </section>
  